import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.FMIS_SERVER_PREFIX}/materialized-view`;
const endpoints = {
    refreshOrganograms: () => `${RESOURCE_ENDPOINT}/refresh-organograms`,
};

export default class MaterializedViewApi {
    public refreshOrganograms = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.refreshOrganograms();
        return HttpService.post(url, payload, params, headers);
    };
}
